/* eslint-disable indent */
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import useAuthToken from '../../../hooks/useAuthToken';
import { PlanPrice, PricingPlan } from '../../../types/Pricing';
import { useAppSelector } from '../../../store/store';
import usePricingPlans from '../../../hooks/usePricingPlans';
import LoadingIcon from '../../../icons/LoadingIcon';
import PricingCard from '../../../landingPage/components/Pricing/PricingCard';
import Loading from '../../common/Loading';

export default function Pricing() {
  const [activeTab] = useState<'month' | 'year'>('month');
  const [price, setPrice] = useState<PricingPlan[]>();
  const { isLoading: loading } = useAuthToken();

  function getPreferredPriceIndex(prices: PlanPrice[], preferred: 'month' | 'year'): number {
    return prices.findIndex(p => p.interval === preferred);
  }

  const { subscription } = useAppSelector(e => e.subscription);
  // Use the hook instead of direct API call - it handles caching
  const { pricingPlans } = usePricingPlans();

  useEffect(() => {
    if (pricingPlans) {
      setPrice(pricingPlans);
    }
  }, [pricingPlans]);

  if (loading) {
    return (
      <div className="grid place-items-center h-screen w-full">
        <div>
          <LoadingIcon width={150} height={150} />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="">
        <>
          {/* <div className="flex justify-center mt-10 border border-[#393939] w-fit mx-auto rounded-[70px] bg-[#18181B]  p-2 items-center">

            <button
              className={`px-4 py-2 rounded-full text-sm font-semibold ${activeTab === 'month' ? 'bg-[#1937E0] text-white' : 'text-[#CDCDCD]'}`}
              onClick={() => setActiveTab('month')}
            >
              Monthly
            </button>
             <button
              className={`px-4 py-2 rounded-full text-sm font-semibold  ${activeTab === 'year' ? 'bg-[#1937E0] text-white' : 'text-[#CDCDCD]'} `}
              onClick={() => setActiveTab('year')}
            >
              Yearly
            </button> 

          </div> */}

                <div className="text-white font-[900] text-[25px] md:text-[30px] mt-4 align-middle text-center mb-4">
            Subscription Plans 
          </div>

          <Box display="flex" gap={2} justifyContent="center" mt={4} flexDirection={{ xs: 'column', md: 'row' }}>
            {price?.length > 0 ? (
              price.every(plan => getPreferredPriceIndex(plan.prices, activeTab) === -1) ? (
                <p className="text-white text-center py-16">No {activeTab === 'year' ? 'yearly' : 'monthly'} plans available right now</p>
              ) : (
                price.map((plan, index) => {
                  const pricingIndex = getPreferredPriceIndex(plan?.prices, activeTab);
                  return pricingIndex >= 0 ? <PricingCard key={index} subscription={subscription} plan={plan} pricingIndex={pricingIndex} redirectFreeUserToBilling={plan.prices[index]?.priceId == 'price_free'} /> : null;
                })
              )
            ) : (
              <Loading height="30vh" />
            )}
          </Box>
        </>
      </div>
    </>
  );
}
